// src/routes/appRoutes.tsx
import { RouteType } from "./config";
import Dashboard from "../Components/Dashboard/Dashboard";
import AccountsOverview from "../Components/AccountsOverview/AccountsOverview";
import NewCases from "../Components/Cases/NewCases/Newcase";
import GeneralCases from "../Components/Cases/GeneralCases/GeneralCases";
import SubmitCase from "../Components/Cases/SubmitCases/SubmitCases";
import Shipments from "../Components/Shipment/Shipments";
import FeeAuditors from "../Components/FeeAuditors/FeeAuditors";
import Invoices from "../Components/Invoices/Invoices";
import UserForm from "../Components/Users/UserForm";
import UploadReports from "../Components/Reports/UploadReports";
import Administrator from "../Components/Administrator/Administrator";
import Users from "../Components/Users/Users";
import Account from "../Components/Account/Account";
import TiersSettings from "../Components/LevelTiers/LevelTiers";
import TiersValue from "../Components/FeeTiers/FeeTiers";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import ImageSearchOutlinedIcon from '@mui/icons-material/ImageSearchOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import userRoles from "../configs/userRolesConfigs";
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined';
import MonthlyFees from "../Components/MonthlyFees/MonthlyFees";
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import NewAccount from "../Components/Account/NewAccount";
import RemovalShipmentDetails from "../Components/RemovalShipmentDetails/RemovalShipmentDetails";
import DownloadReports from "../Components/Reports/DownloadReports";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import { permissions } from "../configs/permissions";
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import AmazonReceiptUploadFiles from "../Components/AmazonReceipt/AmazonReceiptUploadFiles";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <AccountsOverview />,
    state: "home",
  },
  {
    path: "/layout/accounts-overview",
    element: <AccountsOverview />,
    state: "accounts-overview",
    sidebarProps: {
      displayText: "accounts_overview",
      icon: <BusinessCenterOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson, userRoles.cfo],
    requiredPermissions: [permissions.VIEW_DASHBOARD]
  },
  {
    path: "/layout/dashboard",
    element: <Dashboard />,
    state: "dashboard",
    sidebarProps: {
      displayText: "dashboard",
      icon: <BarChartOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson, userRoles.cfo],
    requiredPermissions: [permissions.VIEW_DASHBOARD]
  },
  {
    path: "/layout/administrator/viewStatus",
    element: <Administrator />,
    state: "overview",
    sidebarProps: {
      displayText: "overview",
      icon: <AutoAwesomeMosaicOutlinedIcon />
    },
    allowedRoles: [userRoles.analyst]
  },
  {
    path: "/layout/cases",
    element: <NewCases />,
    state: "cases",
    sidebarProps: {
      displayText: "cases",
      icon: <ImageSearchOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
    requiredPermissions: [permissions.VIEW_CASES],
    child: [
      {
        path: "/layout/cases/general?type=reimbursed",
        element: <GeneralCases />,
        state: "cases.reimbursed",
        sidebarProps: {
          displayText: "cases_reimbursed"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
        requiredPermissions: [permissions.VIEW_CASES_REIMBURSED]
      },
      {
        path: "/layout/cases/rows?type=dismissed",
        element: <SubmitCase />,
        state: "cases.dismissed",
        sidebarProps: {
          displayText: "cases_dismissed"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst]
      },
      {
        index: true,
        element: <NewCases />,
        state: "cases.new"
      },
      {
        path: "/layout/cases/new",
        element: <NewCases />,
        state: "cases.new",
        sidebarProps: {
          displayText: "cases_new"
        },
        allowedRoles: [userRoles.admin]
      },
      {
        path: "/layout/cases/general?type=awaiting",
        element: <GeneralCases />,
        state: "cases.awaiting",
        sidebarProps: {
          displayText: "cases_answered"
        },
        allowedRoles: [userRoles.admin]
      },
    ]
  },
  {
    path: "/layout/shipments",
    element: <Shipments />,
    state: "shipments",
    sidebarProps: {
      displayText: "shipments",
      icon: <LocalShippingOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
    requiredPermissions: [permissions.VIEW_SHIPMENTS]
  },
  {
    path: "/layout/removal-shipment-details",
    element: <RemovalShipmentDetails />,
    state: "removal_shipment_details",
    sidebarProps: {
      displayText: "removal_shipments",
      icon: <WarehouseOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
    requiredPermissions: [permissions.VIEW_REMOVAL_SHIPMENTS]
  },
  {
    path: "/layout/feeAuditors",
    element: <FeeAuditors />,
    state: "feeAuditors",
    sidebarProps: {
      displayText: "fee_auditor",
      icon: <CalculateOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
    requiredPermissions: [permissions.VIEW_FEE_AUDITOR]
  },
  {
    path: "/layout",
    element: <Dashboard />,
    state: "accounts",
    sidebarProps: {
      displayText: "accounts",
      icon: <GroupAddOutlinedIcon />
    },
    child: [],
    allowedRoles: [userRoles.account],
    requiredPermissions: [permissions.VIEW_ACCOUNTS]
  },
  {
    path: "/layout/new-account",
    element: <NewAccount />,
    state: "new_account",
    sidebarProps: {
      displayText: "add_new_account",
       icon: <PersonAddAltOutlinedIcon />
    },
    allowedRoles: [userRoles.account],
    requiredPermissions: [permissions.ADD_NEW_ACCOUNT]
  },
  {
    path: "/layout/upload-amazon-receipts",
    element: <AmazonReceiptUploadFiles />,
    state: "upload_amazon_receipts",
    sidebarProps: {
      displayText: "upload_amazon_receipts",
      icon: <ReceiptLongOutlinedIcon />
    },
    allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
    requiredPermissions: [permissions.UPLOAD_AMAZON_RECEIPTS]
  },
  {
    path: "/settings",
    element: <Invoices />,
    state: "settings",
    sidebarProps: {
      displayText: "settings",
      icon: <SettingsOutlinedIcon />
    },
    child: [
      {
        index: true,
        element: <Invoices />,
        state: "invoices"
      },
      {
        path: "/layout/settings/invoices",
        element: <Invoices />,
        state: "invoices",
        sidebarProps: {
          displayText: "billing"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.salesperson, userRoles.account, userRoles.cfo],
        requiredPermissions: [permissions.VIEW_BILLING]
      },
      {
        path: "/layout/settings/userDetails/1",
        element: <UserForm />,
        state: "user_details",
        sidebarProps: {
          displayText: "user_details"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson, userRoles.cfo],
        requiredPermissions: [permissions.EDIT_USER_DETAILS]
      },
      {
        path: "/layout/settings/upload-reports",
        element: <UploadReports />,
        state: "upload_reports",
        sidebarProps: {
          displayText: "upload_reports"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst]
      },
      {
        path: "/layout/settings/download-reports",
        element: <DownloadReports />,
        state: "download_reports",
        sidebarProps: {
          displayText: "download_reports"
        },
        allowedRoles: [userRoles.admin, userRoles.analyst]
      },
      {
        path: "/layout/settings/monthly-fees",
        element: <MonthlyFees />,
        state: "monthly_fees",
        sidebarProps: {
          displayText: "monthly_fees"
        },
        allowedRoles: [userRoles.salesperson, userRoles.admin]
      },
      {
        path: "/layout/administrator/accounts",
        element: <Account />,
        state: "account",
        sidebarProps: {
          displayText: "accounts"
        },
        allowedRoles: [userRoles.salesperson]
      }
    ]
  },
  // {
  //   path: "/layout/users",
  //   element: <Users />,
  //   state: "users",
  //   sidebarProps: {
  //     displayText: "users",
  //     icon: <PeopleAltOutlinedIcon />
  //   },
  //   allowedRoles: [userRoles.cfo, userRoles.salesperson]
  // },
  {
    path: "/administrator",
    element: <Administrator />,
    state: "administrator",
    sidebarProps: {
      displayText: "administrator",
      icon: <AdminPanelSettingsOutlinedIcon />
    },
    allowedRoles: [userRoles.admin],
    child: [
      {
        index: true,
        element: <Administrator />,
        state: "administrator"
      },
      {
        path: "/layout/administrator/viewStatus",
        element: <Administrator />,
        state: "invoices",
        sidebarProps: {
          displayText: "administrator"
        },
        allowedRoles: [userRoles.admin]
      },
      {
        path: "/layout/administrator/users",
        element: <Users />,
        state: "users",
        sidebarProps: {
          displayText: "users"
        },
        allowedRoles: [userRoles.admin]
      },
      {
        path: "/layout/administrator/accounts",
        element: <Account />,
        state: "account",
        sidebarProps: {
          displayText: "accounts"
        },
        allowedRoles: [userRoles.admin]
      },
      {
        path: "/layout/administrator/tiers",
        element: <TiersSettings />,
        state: "tiers",
        sidebarProps: {
          displayText: "tiers"
        },
        allowedRoles: [userRoles.admin]
      },
      {
        path: "/layout/administrator/shipments",
        element: <TiersValue />,
        state: "shipments",
        sidebarProps: {
          displayText: "shipments"
        },
        allowedRoles: [userRoles.admin]
      }
    ]
  }
];

export const pushAccounts = (accounts = []) => {
  const parentRoute = appRoutes.find((route) => route.state === 'accounts');
  parentRoute.child = [];
  accounts.map((account) => {
    parentRoute.child.push({
      path: `/layout/dashboard/${account.id}`,
      element: <Dashboard />,
      state: "dashboard",
      sidebarProps: {
        displayText: account.label
      },
      allowedRoles: [userRoles.admin, userRoles.analyst, userRoles.account, userRoles.salesperson],
      requiredPermissions: [permissions.VIEW_DASHBOARD_ACCOUNT]
    });
  });
  // parentRoute.child.push({
  //   path: "/layout/new-account",
  //   element: <NewAccount />,
  //   state: "new_account",
  //   sidebarProps: {
  //     displayText: "add_new_account"
  //   },
  //   allowedRoles: [userRoles.account, userRoles.admin]
  // });
};

export default appRoutes;
